import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	config: {
		funnelFeatureFlag: 'creatives_spreadsheet',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('pages.landing.main_funnel.title'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
			uppercase: true,
		}),

		LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => {
			let img = null

			try {
				img = require(`@/assets/landing/spreadsheet-main/${ctx.language}.webp`)
			} catch {
				img = require('@/assets/landing/spreadsheet-main/en.webp')
			}
			return {
				img,
				customStyles: {
					height: '42vh',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
